import React, { useState, useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ChangePassword from "./pages/ChangePassword";
import { authApi } from "./api/services";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

/**
 * 프로젝트의 메인 App 컴포넌트
 * 로그인 상태 관리 및 자동 로그인을 처리합니다.
 */
function App() {
  const [token, setToken] = useState(localStorage.getItem("mallang_access_token"));
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("mallang_user");
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [loading, setLoading] = useState(true);
  const [currentView, setCurrentView] = useState("dashboard"); // 'dashboard' | 'changePassword'

  useEffect(() => {
    const initAuth = async () => {
      const accessToken = localStorage.getItem("mallang_access_token");
      const refreshToken = localStorage.getItem("mallang_refresh_token");

      if (!accessToken && refreshToken) {
        // 액세스 토큰은 없으나 리프레시 토큰이 있는 경우 -> 자동 로그인(토큰 갱신) 시도
        try {
          const response = await authApi.refresh(refreshToken);
          const { 
            access_token, 
            refresh_token, 
            user_type,
            admin 
          } = response.data;
          
          localStorage.setItem("mallang_access_token", access_token);
          if (refresh_token) {
            localStorage.setItem("mallang_refresh_token", refresh_token);
          }
          
          const previousUser = JSON.parse(localStorage.getItem("mallang_user") || "null");
          const userData = {
            name: admin?.name || "관리자",
            organization: admin?.organization || "소속 없음",
            level: admin?.level,
            code: admin?.code,
            email: admin?.email || previousUser?.email,
            user_type
          };
          localStorage.setItem("mallang_user", JSON.stringify(userData));
          
          setToken(access_token);
          setUser(userData);
        } catch (error) {
          // console.error("자동 로그인 실패:", error);
          handleLogout();
        }
      } else if (accessToken) {
        // 이미 액세스 토큰이 있는 경우 저장된 정보를 사용합니다. (getMe 엔드포인트 없음)
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  /**
   * 로그인 성공 시 처리
   */
  const handleLoginSuccess = (newToken, userData) => {
    setToken(newToken);
    setUser(userData);
  };

  /**
   * 로그아웃 처리
   */
  const handleLogout = () => {
    localStorage.removeItem("mallang_access_token");
    localStorage.removeItem("mallang_refresh_token");
    localStorage.removeItem("mallang_user");
    setToken(null);
    setUser(null);
  };

  if (loading) {
    // 로딩 중일 때는 로딩바를 보여줌 (흰 화면 방지)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: 2,
          backgroundColor: "#f5f7fa",
        }}
      >
        <CircularProgress />
        <Typography variant="body2" sx={{ color: "#4f566b" }}>
          로그인 정보를 확인 중입니다...
        </Typography>
      </Box>
    );
  }

  // 인증되지 않은 경우 로그인 페이지 출력
  if (!token) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  // 인증된 경우 대시보드 또는 비밀번호 변경 페이지 출력
  return (
    <>
      {currentView === "dashboard" ? (
        <Dashboard 
          token={token} 
          me={user} 
          logout={handleLogout} 
          onChangePassword={() => setCurrentView("changePassword")} 
        />
      ) : (
        <ChangePassword onBack={() => setCurrentView("dashboard")} />
      )}
    </>
  );
}

export default App;
